import React, { Component } from 'react'

export class Testimonial extends Component {
  render() {
    return (
      <div>
         
      </div>
    )
  }
}

export default Testimonial
